// extracted by mini-css-extract-plugin
export default {"-large":"source-tag-module__-large--LDRqB","container":"source-tag-module__container--Dso2J","content":"source-tag-module__content--QcdgC"};